import MaterialTable, { MTableToolbar } from "material-table";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { useEffect, useRef, useState } from "react";
import SlidingPane from "react-sliding-pane";
import Select from "react-select";
import jsPDF from "jspdf";
import { autoTable } from 'jspdf-autotable'


import Helper from "../../../Helper";
import { getTrans as t } from "../../../Localization/translations";
import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";
import AddcategoryService from "../../../services/category/categoryAddServices";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

function AssetConcentration() {
  var contractNumber = "";
  var assetNumber = "";
  const [state1, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  const tableRef = useRef();
  let navigate = useNavigate();

  const [selectedValue2, setSelectedValue2] = useState(null);
  const [options2, setOptions2] = useState([]);
  const [isLoading2, setIsLoading2] = useState(false);
  const [inputvalue2, setValue2] = useState("");
  const [currentPage2, setCurrentPage2] = useState(1);

  const [selectedValueAsset, setSelectedValueAsset] = useState(null);
  const [optionsAsset, setOptionsAsset] = useState([]);
  const [isLoadingAsset, setIsLoadingAsset] = useState(false);
  const [inputvalueAsset, setValueAsset] = useState("");
  const [currentPageAsset, setCurrentPageAsset] = useState(1);


  const [selectedValueState, setSelectedValueState] = useState(null); // State for selected state
  const [optionsState, setOptionsState] = useState([]); // State for state options
  const [isLoadingState, setIsLoadingState] = useState(false); // Loading state for states
  const [inputvalueState, setInputValueState] = useState(""); // Input value for state search
  const [currentPageState, setCurrentPageState] = useState(1); // Pagination for states

  const [inputvalue, setValue] = useState("");
  const [status, setStatus] = useState("");
  const [asset_type, setAsset_type] = useState("");

  const [category_list, setCategory_list] = useState([]);
  const [sub_categories, setSub_categories] = useState([]);
  const [selected_category, setSelected_category] = useState("");
  const [selected_sub_category, setselected_sub_category] = useState("");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [summaryData, setSummaryData] = useState([]);
  const [pageSize, setPageSize] = useState(10); // Initial page size

  const [permissionss, setPermission] = useState(
    localStorage.getItem("permissions")
  );

  const loadOptionsStateData = async (value, page) => {
    try {
      setIsLoadingState(true);
      const stateQuery = value === "" ? "%" : value; // Use % for all states
      const response = await fetch(
        // `${API}helper/ajax/load-allstates/?state_name=${encodeURIComponent(stateQuery)}&page=${page}&per_page=50`,
        `${API}helper/ajax/load-states/${231}/`,
        { headers: authHeader() }
      );
      const result = await response.json();
      if (result && result && result.length > 0) {
        const newOptions = result.map((state) => ({
          name: state.name,
          // label: state.name, // For react-select
        }));
        setOptionsState((prevOptions) => [...prevOptions, ...newOptions]);
        setCurrentPageState((prevPage) => prevPage + 1);
      } else {
        console.error("No states received or empty array from API.");
      }
      setIsLoadingState(false);
    } catch (error) {
      console.error("Error fetching states:", error);
      setIsLoadingState(false);
    }
  };

   useEffect(() => {
    loadOptionsStateData("%", 1);
  }, []);

  const permissionsArray = permissionss.split(",");
  const handleClear = () => {
    // setSelectedValue(null);
    setSelectedValue2(null);
    setSelectedValueAsset(null);
    setSelectedValueState(null); // Clear state filter
    setStatus("");
    setValue("");
    setValueAsset("");
    setAsset_type("");
    setselected_sub_category("");
    setSelected_category("");

    tableRef.current.onQueryChange();
  };

  const handleInputStateChange = (value) => {
    setInputValueState(value);
    setCurrentPageState(1);
    setOptionsState([]);
    loadOptionsStateData(value, 1);
  };

  const handleStateMenuScrollToBottom = () => {
    loadOptionsStateData(inputvalueState, currentPageState);
  };

  const handleStateChange = (value) => {
    setSelectedValueState(value);
  };

  const handleInputChangeData = (value) => {
    setValue2(value);
    setCurrentPage2(1);
    setOptions2([]);
    loadOptionsData(value, 1);
  };

  const handleInputAssetChangeData = (value) => {
    setValueAsset(value);
    setCurrentPageAsset(1);
    setOptionsAsset([]);
    loadOptionsAssetData(value, 1);
  };

  const handlechangeAsset = (value) => {
    setSelectedValueAsset(value);
  };

  const handleAssetMenuScrollToBottom = () => {
    loadOptionsAssetData(inputvalueAsset, currentPageAsset);
  };

  const loadOptionsAssetData = async (value, page) => {
    try {
      if (value !== "") {
        setIsLoadingAsset(true);
        const response = await fetch(
          `${API}contracts/asset/filter/?asset_number=${value}&page=${page}`,
          { headers: authHeader() }
        );
        const newData = await response.json();
        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data;

          setOptionsAsset((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPageAsset((prevPage) => prevPage + 1);
        } else {
          console.error("No data received or empty array from API.");
        }
        setIsLoadingAsset(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoadingAsset(false);
    }
  };

  const handleMenuScrollToBottom = () => {
    loadOptionsData(inputvalue2, currentPage2);
  };

  const loadOptionsData = async (value, page) => {
    try {
      if (value !== "") {
        setIsLoading2(true);
        const response = await fetch(
          // `${API}contracts/contractsactive/filter/?id=${value}&page=${page}`,
          `${API}contracts/contracts/filter/?id=${value}&page=${page}`,
          { headers: authHeader() }
        );
        const newData = await response.json();

        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data;

          setOptions2((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPage2((prevPage) => prevPage + 1);
        } else {
          console.error("No data received or empty array from API.");
        }
        setIsLoading2(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading2(false);
    }
  };

  const handelChange2 = (value1) => {
    setSelectedValue2(value1);
  };

  function getAlignmentStyles(columns) {
    const alignmentStyles = {};
    columns.forEach((columnDef, index) => {
      if (columnDef.field === "financed_amount") {
        alignmentStyles[index] = { halign: "right" };
      } else {
        alignmentStyles[index] = { halign: "left" };
      }
    });
    return alignmentStyles;
  }

  const fetchAllDataForExport = async () => {
    let allData = [];
    let currentPage = 0;

    while (true) {
      const query = {
        pageSize: 100, // Increase page size for exports to reduce API calls
        page: currentPage,
        search: "",
      };

      assetNumber = selectedValueAsset ? selectedValueAsset.asset_number : "";
      contractNumber = selectedValue2 ? selectedValue2.contract_number : "";

      let url = `${API}helper/asset-concentration-report/?`;
      url += `per_page=${query.pageSize}`;
      url += `&page=${query.page + 1}`;
      url += `&search=${query.search}`;
      url += `&contractNumber=${contractNumber}`;
      url += `&assetNumber=${assetNumber}`;
      url += `&status=${status}`;
      url += `&item_type=${asset_type}`;
      url += `&category=${selected_category}`;
      url += `&subcategory=${selected_sub_category}`;
      url += `&state=${selectedValueState ? selectedValueState.name : ""}`; // Add state filter


      try {
        const response = await fetch(url, { headers: authHeader() });
        const result = await response.json();
        if (result.data.data.items.length === 0) {
          break;
        }
        allData = allData.concat(result.data.data.items);
        currentPage++;
      } catch (error) {
        console.error("Error fetching data:", error);
        break;
      }
    }
    return allData;
  };
  // const fetchAllDataForExport = async () => {
  //   let allData = [];
  //   let currentPage = 0;
  //   const pageSize = 10; // Your page size

  //   while (true) {
  //     const query = {
  //       pageSize,
  //       page: currentPage,
  //       search: "",
  //     };

  //     // Modify the logic here to handle customerName if needed

  //     // if (selectedValue) {
  //     //   customerName = selectedValue.id;
  //     // }

  //     assetNumber = "";
  //     if (selectedValue2) {
  //       contractNumber = selectedValue2.contract_number;
  //     }

  //     if (selectedValueAsset) {
  //       assetNumber = selectedValueAsset.asset_number;
  //     }

  //     const url =
  //       API +
  //       "helper/asset-concentration-report/?" +
  //       "&per_page=" +
  //       query.pageSize +
  //       "&page=" +
  //       (query.page + 1) +
  //       "&search=" +
  //       query.search +
  //       "&contractNumber=" +
  //       contractNumber +
  //       "&assetNumber=" +
  //       assetNumber;

  //     try {
  //       const response = await fetch(url, { headers: authHeader() });
  //       const result = await response.json();

  //       if (result.data.length === 0) {
  //         break;
  //       }

  //       allData = allData.concat(result.data.data.items);
  //       currentPage++;
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //       break;
  //     }
  //   }

  //   return allData;
  // };

  const handleAssetView = (
    contract_id,
    conractstatus,
    contracttype,
    asset_id
  ) => {
    if (conractstatus === "Active" || conractstatus === "PaidOff") {
      navigate(`/contract/view?Asset=${asset_id}`, { state: contract_id });
    } else if (conractstatus === "Terminated") {
      navigate(`/contract/view?Asset=${asset_id}`, { state: contract_id });
    } else {
      if (contracttype === "Loan") {
        navigate(`/editloancontract?Asset=${asset_id}`, { state: contract_id });
      } else if (contracttype === "Rental") {
        navigate(`/editrentalcontract?Asset=${asset_id}`, {
          state: contract_id,
        });
      } else if (contracttype === "Line of Credit") {
        navigate(`/edit-line-of-credit-contract?Asset=${asset_id}`, {
          state: contract_id,
        });
      } else {
        navigate(`/contract/edit?Asset=${asset_id}`, { state: contract_id });
      }
    }
  };

  const handleViewRedirect = (id, status, contract_type) => {
    if (status === "Active" || status === "PaidOff") {
      navigate("/contract/view", { state: id });
    } else if (status === "Terminated") {
      navigate("/contract/view", { state: id });
    } else {
      if (contract_type === "Loan") {
        navigate("/editloancontract", { state: id });
      } else if (contract_type === "Rental") {
        navigate("/editrentalcontract", { state: id });
      } else if (contract_type === "Line of Credit") {
        navigate("/edit-line-of-credit-contract", { state: id });
      } else {
        navigate("/contract/edit", { state: id });
      }
    }
  };

  const handleEdit = (id) => {
    navigate("/itemmasteredit", { state: id });
  };

  useEffect(() => {
    AddcategoryService.viewListCategory().then((response) => {
      setCategory_list(response.data.data.categories);
    });
  }, []);
  const handleCategoryChange = (e) => {
    const selectedValue = e.target.value;
    setSelected_category(selectedValue);
    // handleItemType(selectedValue)
  };

  useEffect(() => {
    if (selected_category !== "") {
      const matchedCategory = category_list.find(
        (cat) => cat.id === Number(selected_category)
      );
      const category_name = matchedCategory.category_name;
      const item_types = matchedCategory?.item_type;
      AddcategoryService.filtersubCategory(category_name).then((response) => {
        const fetchedSubCategories = response.data.sub_categories;
        setSub_categories(fetchedSubCategories);
        const defaultSubCategory = fetchedSubCategories.find(
          (subCat) => subCat.is_default === true
        );
        if (defaultSubCategory) {
          setselected_sub_category(defaultSubCategory.id.toString());
        } else {
          setselected_sub_category("");
        }
      });
    }
  }, [selected_category, category_list]);

  const handlesubCategoryChange = (e) => {
    const selectedValue = e.target.value;
    setselected_sub_category(selectedValue);
  };

  const handleDialogOpen = () => {
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

    const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    tableRef.current.onQueryChange({ page: 0, pageSize: newPageSize });
  };

  return (
    <>
      <div className="container-fluid">
        <MaterialTable
          tableRef={tableRef}
          style={{
            padding: "0.5rem 0.5rem",
            backgroundColor: "var(--bs-table-bg)",
            borderBottomWidth: "1px",
            boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
          }}
          // title={<h5 className="mb-0">{t("Asset Register")}</h5>}
          title={
            <>
              <h5 className="mb-0">{t("Asset Concentration By Category")}</h5>

              <Typography
                variant="body2"
                style={{
                  color: "#245C7F",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={handleDialogOpen}
              >
                {t("Summary")}
              </Typography>
            </>
          }
          columns={[
            {
              title: `${t("Item Number")}`,
              field: "item_name",
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
              render: (rowData) => (
                <div
                  onClick={() =>
                    navigate(`/itemmasterview`, { state: rowData.id })
                  }
                >
                  <>
                    <div className="d-xl-none tc d-md-none d-lg-none ">
                      {t("Item Number")}
                    </div>
                    <div className="hyperlink">{rowData.item_name}</div>
                  </>
                </div>
              ),
            },
            {
              title: `${t("Item Type")}`,
              // field: "asset_desc",
              field: "item_type",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Item Type")}
                  </div>
                  <div>{rowData.item_type ? rowData.item_type : "None"}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
            {
                          title: `${t("Description")}`,
                          // field: "asset_desc",
                          field: "description",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">
                                {t("Description")}
                              </div>
                              <div>
                                {rowData.description ? rowData.description : "None"}
                              </div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
            {
                          title: `${t("Serial Number")}`,
                          field: "serial_number",
                          render: (rowData) => (
                            <>
                              <div
                                className={`d-xl-none tc d-md-none d-lg-none`}
                                style={{
                                  textAlign: rowData.isSmallScreen ? "left" : "right",
                                  fontSize: "12px",
                                  fontWeight: rowData.isSmallScreen ? "bold" : "",
                                }}
                              >
                                {t("Serial Number")}
                              </div>
                              <div
                                className={`d-none d-xl-block d-lg-block text-right`}
                                style={{ textAlign: "right", fontSize: "12px" }}
                              >
                                {rowData.serial_number ? rowData.serial_number : ""}
                              </div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "right",
                          },
                          // cellStyle: {
                          //   textAlign: "right",
                          //   fontSize: 12,
                          // },
                        },

              {
                           title: `${t("Make")}`,
                           field: "make",
                           render: (rowData) => (
                             <>
                               <div
                                 className={`d-xl-none tc d-md-none d-lg-none`}
                                 style={{
                                   textAlign: rowData.isSmallScreen ? "left" : "right",
                                   fontSize: "12px",
                                   fontWeight: rowData.isSmallScreen ? "bold" : "",
                                 }}
                               >
                                 {t("Make")}
                               </div>
                               <div
                                 className={`d-none d-xl-block d-lg-block text-right`}
                                 style={{ textAlign: "right", fontSize: "12px" }}
                               >
                                 {rowData.make}
                               </div>
                             </>
                           ),
                           headerStyle: {
                             verticalAlign: "inherit",
                             fontWeight: "bold",
                             textAlign: "right",
                           },
                           // cellStyle: {
                           //   textAlign: "right",
                           //   fontSize: 12,
                           // },
                         },
                         {
                           title: `${t("Model")}`,
                           field: "model",
                           render: (rowData) => (
                             <>
                               <div
                                 className={`d-xl-none tc d-md-none d-lg-none`}
                                 style={{
                                   textAlign: rowData.isSmallScreen ? "left" : "right",
                                   fontSize: "12px",
                                   fontWeight: rowData.isSmallScreen ? "bold" : "",
                                 }}
                               >
                                 {t("Model")}
                               </div>
                               <div
                                 className={`d-none d-xl-block d-lg-block text-right`}
                                 style={{ textAlign: "right", fontSize: "12px" }}
                               >
                                 {rowData.model}
                               </div>
                             </>
                           ),
                           headerStyle: {
                             verticalAlign: "inherit",
                             fontWeight: "bold",
                             textAlign: "right",
                           },
                           // cellStyle: {
                           //   textAlign: "right",
                           //   fontSize: 12,
                           // },
                         },

            {
              title: `${t("Net Book Value")}`,
              field: "netbookvalue",
              render: (rowData) => (
                <>
                  <div
                    className={`d-xl-none tc d-md-none d-lg-none`}
                    style={{
                      textAlign: rowData.isSmallScreen ? "left" : "right",
                      fontSize: "12px",
                      fontWeight: rowData.isSmallScreen ? "bold" : "",
                    }}
                  >
                    {t("Net Book Value")}
                  </div>
                  <div
                    className={`d-none d-xl-block d-lg-block text-right`}
                    style={{ textAlign: "right", fontSize: "12px" }}
                  >
                    {rowData.netbookvalue}
                  </div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "right",
              },
              // cellStyle: {
              //   textAlign: "right",
              //   fontSize: 12,
              // },
            },
            {
              title: `${t("Contract Number")}`,
              // field: "contractname",
              field: "contract_number",
              render: (rowData) => (
                <div>
                  <>
                    <div className="d-xl-none tc d-md-none d-lg-none">
                      {t("Contract Number")}
                    </div>
                    <div
                      className="hyperlink"
                      onClick={() =>
                        handleViewRedirect(
                          rowData.contract_id,
                          rowData.conractstatus,
                          rowData.contracttype
                        )
                      }
                    >
                      {rowData.contract_number ? rowData.contract_number : ""}
                    </div>
                  </>
                </div>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
            {
              title: `${t("Asset No")}`,
              field: "asset_number",
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
              render: (rowData) => (
                <div>
                  <>
                    <div className="d-xl-none tc d-md-none d-lg-none ">
                      {t("Asset No")}
                    </div>
                    <div
                      className="hyperlink"
                      onClick={() =>
                        handleAssetView(
                          rowData.contract_id,
                          rowData.conractstatus,
                          rowData.contracttype,
                          rowData.asset_id
                        )
                      }
                    >
                      {rowData.asset_number}
                    </div>
                  </>
                </div>
              ),
            },
           
            {
              title: `${t("Category")}`,
              field: "category",
              hidden: false,
              hiddenByColumnsButton: false,
              width: "100px",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Category")}
                  </div>
                  <div>
                    {rowData.category ? rowData.category : ""}
                  </div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: (rowData) => ({
                textAlign: rowData?.textAlign || "left",
                fontSize: rowData?.fontSize || 12,
              }),
            },
            {
              title: `${t("Sub category Name")}`,
              field: "sub_category",
              hidden: false,
              hiddenByColumnsButton: false,
              width: "100px",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Sub category Name")}
                  </div>
                  <div>
                    {rowData.sub_category ? rowData.sub_category : ""}
                  </div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: (rowData) => ({
                textAlign: rowData?.textAlign || "left",
                fontSize: rowData?.fontSize || 12,
              }),
            },
            {
              title: `${t("Country")}`,
              field: "country",
              hidden: false,
              hiddenByColumnsButton: false,
              width: "100px",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Country")}
                  </div>
                  <div>
                    {rowData.country ? rowData.country : ""}
                  </div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: (rowData) => ({
                textAlign: rowData?.textAlign || "left",
                fontSize: rowData?.fontSize || 12,
              }),
            },
            {
              title: `${t("State")}`,
              field: "state",
              hidden: false,
              hiddenByColumnsButton: false,
              width: "100px",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("State")}
                  </div>
                  <div>
                    {rowData.state ? rowData.state : ""}
                  </div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: (rowData) => ({
                textAlign: rowData?.textAlign || "left",
                fontSize: rowData?.fontSize || 12,
              }),
            },
            {
              title: `${t("Status")}`,
              field: "status",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Status")}
                  </div>
                  <div>{rowData.status ? rowData.status : "None"}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              const { orderBy, orderDirection } = query;

              if (selectedValue2) {
                contractNumber = selectedValue2.contract_number;
              }
              if (selectedValueAsset) {
                assetNumber = selectedValueAsset.asset_number;
              }

              let url = API + "helper/asset-concentration-report/?";
              url += "per_page=" + query.pageSize;
              url += "&page=" + (query.page + 1);
              url += "&search=" + query.search;
              url += `&contractNumber=${
                contractNumber !== "" ? contractNumber : ""
              }`;
              url += `&assetNumber=${assetNumber !== "" ? assetNumber : ""}`;
              url += `&status=${status !== "" ? status : ""}`;
              url += `&item_type=${asset_type !== "" ? asset_type : ""}`;
              url += `&category=${
                selected_category !== "" ? selected_category : ""
              }`;
              url += `&subcategory=${
                selected_sub_category !== "" ? selected_sub_category : ""
              }`;
               url += `&state=${
                selectedValueState ? selectedValueState.name : ""
              }`;
              if (orderBy) {
                url += `&orderBy=${orderBy.field}`;
                url += `&orderDirection=${orderDirection}`;
              }
              fetch(url, { headers: authHeader() })
                .then((response) => response.json())
                .then((result) => {
                     setSummaryData(result.data.data.summary.categories)
                  resolve({
                    data:
                    query.orderBy && query.orderDirection
                    ? _.orderBy(
                            result.data.data.items,
                            [query.orderBy.field],
                            [query.orderDirection]
                          )
                          : result.data.data.items,
                          page: result.page - 1,
                          totalCount: result.total,
                        });
                        
                });
            })
          }
          actions={[
            (rowData) => ({
              icon: () =>
                permissionss &&
                permissionsArray.includes("change_itemmaster") === true ? (
                  <img
                    src={process.env.PUBLIC_URL + "/static/images/ic-edit.svg"}
                    alt="edit"
                  />
                ) : (
                  ""
                ),
              tooltip: "Edit",
              onClick:
                permissionss &&
                permissionsArray.includes("change_itemmaster") === true
                  ? (event, rowData) => {
                      handleEdit(rowData.id);
                    }
                  : "",
              // hidden: rowData.status === "Inventory" ? false : true
            }),
          ]}
          components={{
            Toolbar: (props) => (
              <div className="MuiToolbar-root MTableToolbar-spacer-21  my-temp-class">
                <MTableToolbar {...props} />
                {/* {id === undefined &&  */}
                <span
                  onClick={() => setState({ isPaneOpen: true })}
                  style={{
                    color: "#b4b7c5",
                    paddingRight: "10px",
                    cursor: "pointer",
                  }}
                >
                  {/* <i class="fa fa-light fa-filter"></i> */}
                  <img
                    alt=""
                    src={
                      process.env.PUBLIC_URL + "/static/images/ic-filter.svg"
                    }
                  />
                </span>
                {/* } */}
              </div>
            ),
          }}
          options={{
            headerStyle: {
              backgroundColor: "white",
              color: "#245C7F",
              fontSize: 12,
            },
            rowStyle: (rowData, index) => {
              if (index % 2) {
                return { backgroundColor: "#fff" };
              }
            },
            sorting: true,
            search: true,
            toolbar: true,
            paging: true,
            pageSize: 10, // make initial page size
            emptyRowsWhenPaging: false, // To avoid of having empty rows
            pageSizeOptions: [10, 25, 50, 100],
            paginationType: "stepped",
            showFirstLastPageButtons: false,
            actionsColumnIndex: -1,
            columnsButton: true,
            exportButton: true,
            exportAllData: true,

            exportFileName: "Inventory Report",
           
            exportCsv: async (columns, data) => {
              try {
                const allData = await fetchAllDataForExport();
                if (allData.length === 0) {
                  console.error("No data found for CSV export");
                  return;
                }
                const csvColumns = [
                  { title: "Item Number", field: "item_name" },
                  { title: "Item Type", field: "item_type" },
                  { title: "serial Number", field: "serial_number" },
                  { title: "Description", field: "description" },
                  { title: "Make", field: "make" },
                  { title: "Model", field: "model" },
                  { title: "Net Book Value", field: "netbookvalue" },
                  { title: "Contract Number", field: "contract_number" },
                  { title: "Asset No", field: "asset_number" },
                  { title: "Category", field: "category" },
                  { title: "Sub Category", field: "sub_category" },
                  { title: "Status", field: "status" },
                  { title: "Country", field: "country" },
                  { title: "State", field: "state" },
                  // { title: "Manufacturer", field: "make" },
                  // { title: "Year of Manufacture", field: "yearofmanufacture" },
                  // { title: "Date Placed in Service", field: "dateplacedinservice" },
                  // { title: "Life in Months", field: "lifeinmonths" },
                  // { title: "Original Cost", field: "originalcost" },
                ];
                const csvColumnTitles = csvColumns.map((column) => column.title);
                const title = "Asset Concentration By Category Report";
                const currentDate = new Date().toLocaleDateString();
                let csvContentWithInfo = `${title}\n`;
                if (inputvalueAsset) csvContentWithInfo += `Filter By Asset Number: ${inputvalueAsset}\n`;
                if (selectedValue2) csvContentWithInfo += `Filter By Contract Number: ${selectedValue2.contract_number}\n`;
                if (status) csvContentWithInfo += `Filter By Status: ${status}\n`;
                if (asset_type) csvContentWithInfo += `Filter By Item Type: ${asset_type}\n`;
                if (selected_category) {
                  const category = category_list.find((cat) => cat.id === Number(selected_category));
                  csvContentWithInfo += `Filter By Category: ${category?.category_name || ""}\n`;
                }
                if (selected_sub_category) {
                  const subcategory = sub_categories.find((sub) => sub.id === Number(selected_sub_category));
                  csvContentWithInfo += `Filter By Subcategory: ${subcategory?.sub_category_name || ""}\n`;
                }
                csvContentWithInfo += `Date: ${currentDate}\n\n`;
                const csvData = allData.map((rowData) =>
                  csvColumns.map((columnDef) => {
                    if (columnDef.field === "netbookvalue") {
                      return Helper.Amount(rowData[columnDef.field]) || "";
                    } else if (columnDef.field === "dateplacedinservice") {
                      return rowData[columnDef.field] ? Helper.DateNormal(rowData[columnDef.field]) : "";
                    } else {
                      return rowData[columnDef.field] || "";
                    }
                  })
                );
                const csvRows = [csvColumnTitles, ...csvData];
                const csvContent = `${csvContentWithInfo}${csvRows.map((row) => row.join(",")).join("\n")}`;
                const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = "AssetConcentrationReport.csv";
                link.style.display = "none";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              } catch (error) {
                console.error("Error exporting CSV:", error);
              }
            },
           
            exportPdf: async (columns, data) => {
              try {
                const allData = await fetchAllDataForExport();
                if (allData.length === 0) {
                  console.error("No data found for PDF export");
                  return;
                }
                const pdfColumns = [
                  { title: "Item Number", field: "item_name" },
                  { title: "Item Type", field: "item_type" },
                  { title: "serial Number", field: "serial_number" },
                  { title: "Description", field: "description" },
                  { title: "Make", field: "make" },
                  { title: "Model", field: "model" },
                  { title: "Net Book Value", field: "netbookvalue" },
                  { title: "Contract Number", field: "contract_number" },
                  { title: "Asset No", field: "asset_number" },
                  { title: "Category", field: "category" },
                  { title: "Sub Category", field: "sub_category" },
                  { title: "Country", field: "country" },
                  { title: "State", field: "state" },
                  { title: "Status", field: "status" },
                  // { title: "Manufacturer", field: "make" },
                  // { title: "Year of Manufacture", field: "yearofmanufacture" },
                  // { title: "Date Placed in Service", field: "dateplacedinservice" },
                  // { title: "Life in Months", field: "lifeinmonths" },
                  // { title: "Original Cost", field: "originalcost" },
                ];
                const doc = new jsPDF();
                doc.setFont("helvetica", "bold");
                doc.setFontSize(16);
                const title = "Asset Concentration By Category Report";
                doc.text(title, 14, 10);
                doc.setFontSize(12);
                doc.setFont("helvetica", "normal");
                const currentDate = new Date().toLocaleDateString();
                let yPos = 15;
                doc.text(`Date: ${currentDate}`, 14, yPos);
                yPos += 5;
                if (inputvalueAsset) {
                  doc.text(`Filter By Asset Number: ${inputvalueAsset}`, 14, yPos);
                  yPos += 5;
                }
                if (selectedValue2) {
                  doc.text(`Filter By Contract Number: ${selectedValue2.contract_number}`, 14, yPos);
                  yPos += 5;
                }
                if (status) {
                  doc.text(`Filter By Status: ${status}`, 14, yPos);
                  yPos += 5;
                }
                if (asset_type) {
                  doc.text(`Filter By Item Type: ${asset_type}`, 14, yPos);
                  yPos += 5;
                }
                if (selected_category) {
                  const category = category_list.find((cat) => cat.id === Number(selected_category));
                  doc.text(`Filter By Category: ${category?.category_name || ""}`, 14, yPos);
                  yPos += 5;
                }
                if (selected_sub_category) {
                  const subcategory = sub_categories.find((sub) => sub.id === Number(selected_sub_category));
                  doc.text(`Filter By Subcategory: ${subcategory?.sub_category_name || ""}`, 14, yPos);
                  yPos += 5;
                }
                const tableStartY = yPos + 5;
                const columnTitles = pdfColumns.map((columnDef) => columnDef.title);
                const pdfData = allData.map((rowData) =>
                  pdfColumns.map((columnDef) => {
                    if (columnDef.field === "netbookvalue") {
                      return Helper.Amount(rowData[columnDef.field]) || "";
                    } else if (columnDef.field === "dateplacedinservice") {
                      return rowData[columnDef.field] ? Helper.DateNormal(rowData[columnDef.field]) : "";
                    } else {
                      return rowData[columnDef.field] || "";
                    }
                  })
                );
                // doc.autoTable({
                autoTable(doc,{
                  head: [columnTitles],
                  body: pdfData.slice(1),
                  startY: tableStartY,
                  columnStyles: getAlignmentStyles(pdfColumns),
                });
                doc.save("AssetConcentrationReport.pdf");
              } catch (error) {
                console.error("Error exporting PDF:", error);
              }
            },
            
          }}
        />
      </div>
      <SlidingPane
        className="some-custom-class"
        overlayClassName="some-custom-overlay-class"
        width="40% !important"
        isOpen={state1.isPaneOpen}
        title="Filter By"
        subtitle=""
        onRequestClose={() => {
          setState({ isPaneOpen: false });
        }}
      >
        <div className="col-xl-12">
          {/* <div className="form-group row">
            <label className="col-lg-12 col-form-label">
              {t("Contract Number")}
            </label>
            <div className="col-lg-12">
              <Select
                value={selectedValue2}
                filterOption={false}
                options={options2}
                isClearable
                onInputChange={handleInputChangeData}
                getOptionLabel={(options) => options.contract_number}
                getOptionValue={(options) => options.contract_number}
                isLoading={isLoading2}
                placeholder={t("Search for Contract(%for All)")}
                onMenuScrollToBottom={handleMenuScrollToBottom}
                onChange={handelChange2}
              />
            </div>
          </div>
        </div>
        <div className="col-xl-12">
          <div className="form-group row">
            <label className="col-lg-12 col-form-label">
              {t("Asset Number")}
            </label>
            <div className="col-lg-12"> */}
              {/* <input
                className="form-control" 
                onChange={(e) => handlechangeAsset(e.target.value)}
              /> */}
              {/* <Select
                value={selectedValueAsset}
                filterOption={false}
                options={optionsAsset}
                isClearable
                onInputChange={handleInputAssetChangeData}
                getOptionLabel={(options) => options.asset_number}
                getOptionValue={(options) => options.asset_number}
                isLoading={isLoadingAsset}
                placeholder={t("Search for Asset(%for All)")}
                onMenuScrollToBottom={handleAssetMenuScrollToBottom}
                onChange={handlechangeAsset}
              />
            </div>
          </div> */}
        </div>
        <div className="col-xl-12">
          <div className="form-group row">
            <label className="col-lg-12 col-form-label">{t("State")}</label>
            <div className="col-lg-12">
              <Select
                value={selectedValueState}
                // filterOption={false}
                options={optionsState}
                isClearable
                // onInputChange={handleInputStateChange}
                getOptionLabel={(options) => options.name}
                getOptionValue={(options) => options.name}
                isLoading={isLoadingState}
                placeholder={t("Search for State")}
                onMenuScrollToBottom={handleStateMenuScrollToBottom}
                onChange={handleStateChange}
              />
            </div>
          </div>
        </div>
        <div className="col-xl-12">
          <div className="form-group row">
            <label className="col-lg-12 col-form-label">{t("Status")}</label>
            <div className="col-lg-12">
              <select
                className="form-control"
                name="status"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="">Select Status</option>
                <option value="Inventory">Inventory</option>
                <option value="Available for Lease">Available for Lease</option>
                <option value="Available for Rent">Available for Rent</option>
                <option value="Available for Sale">Available for Sale</option>
                <option value="In Transit">In Transit</option>
                <option value="Leased">Leased</option>
                <option value="Rented">Rented</option>
                <option value="Scrapped">Scrapped</option>
                <option value="Sold">Sold</option>
              </select>
            </div>
          </div>
        </div>
        {/* <div className="col-xl-12">
          <div className="form-group row">
            <label className="col-lg-12 col-form-label">{t("Item Type")}</label>
            <div className="col-lg-12">
              <select
                className="form-control"
                name="item_type"
                value={asset_type}
                onChange={(e) => setAsset_type(e.target.value)}
              >
                <option value="">Select Value</option>
                <option value="Vehicle">Vehicle</option>
                <option value="Equipment">Equipment</option>
              </select>
            </div>
            <input type="hidden" id="contract_status" value="" />
          </div>
        </div> */}
        <div className="form-group row">
          <div className="col-sm-6">
            <label className="col-form-label ">{t("Category")} </label>
            <select
              className="form-control"
              name="category"
              onChange={(e) => {
                handleCategoryChange(e);
              }}
              // {...register("category", { onChange: (e) => { handleCategoryChange(e) }, required: true })}
              value={selected_category}
            >
              <option value="">Select Category</option>
              {category_list.map((val, i) => (
                <option key={i} value={val.id}>
                  {val.category_name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-sm-6">
            <label className="col-form-label ">{t("Sub Category")} </label>
            <select
              className="form-control"
              name="subcategory"
              value={selected_sub_category}
              onChange={(e) => {
                handlesubCategoryChange(e);
              }}
              // {...register("subcategory", { onChange: (e) => { handlesubCategoryChange(e) }, required: true })}
            >
              <option value="">Select Subcategory</option>
              {sub_categories.map((val) => (
                <option key={val.id} value={val.id}>
                  {val.sub_category_name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="col-xl-12">
          <div className="form-group row">
            <div className="col-lg-12 text-left" style={{ marginTop: "30px" }}>
              <button
                type="button"
                className="clearReceipt btn bg-gradient-secondary btn-m ms-auto mb-0"
                onClick={handleClear}
              >
                {t("Reset")}
              </button>
              &nbsp;&nbsp;
              <button
                type="button"
                className="filter add btn btn-primary btn-m ms-auto mb-0"
                onClick={() => Helper.handleSearch(tableRef)}
              >
                {t("Apply")}
              </button>
              &nbsp;&nbsp;
            </div>
          </div>
        </div>
      </SlidingPane>
      <Dialog
        open={isDialogOpen}
        onClose={handleDialogClose}
        PaperProps={{
          style: {
            width: "600px",
            maxWidth: "90%",
            borderRadius: "8px",
          },
        }}
      >
        <DialogTitle
          style={{
            fontWeight: "bold",
            color: "#1E88E5",
            borderBottom: "1px solid #E0E0E0",
            paddingBottom: "10px",
          }}
        >
          {t("Asset Concentration By Category")}
        </DialogTitle>
        <DialogContent>
          <div style={{ overflowX: "auto" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginTop: "10px",
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      textAlign: "left",
                      padding: "10px",
                      backgroundColor: "#E3F2FD",
                      color: "#1565C0",
                      fontWeight: "bold",
                      borderBottom: "2px solid #B0BEC5",
                    }}
                  >
                    Category
                  </th>
                  <th
                    style={{
                      textAlign: "right",
                      padding: "10px",
                      backgroundColor: "#E3F2FD",
                      color: "#1565C0",
                      fontWeight: "bold",
                      borderBottom: "2px solid #B0BEC5",
                    }}
                  >
                    Total
                  </th>
                  <th
                    style={{
                      textAlign: "right",
                      padding: "10px",
                      backgroundColor: "#E3F2FD",
                      color: "#1565C0",
                      fontWeight: "bold",
                      borderBottom: "2px solid #B0BEC5",
                    }}
                  >
                    Percentage
                  </th>
                </tr>
              </thead>
              <tbody>
                {summaryData.map(({ category, total_value,category_percentage }) => (
                  <tr
                    key={category}
                    style={{
                      backgroundColor: "transparent",
                      borderBottom: "1px solid #F5F5F5",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px",
                        color: "#757575",
                        // fontWeight: "bold",
                      }}
                    >
                      {category}
                    </td>
                    <td
                      style={{
                        padding: "10px",
                        color: "#757575",
                        textAlign: "right",
                        // fontWeight: "bold",
                      }}
                    >
                      {Helper.Amount(total_value)}
                    </td>
                    <td
                      style={{
                        padding: "10px",
                        textAlign: "right",
                        color: "#757575",
                        // fontWeight: "bold",
                      }}
                    >
                      {category_percentage.toFixed(2)}%
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleDialogClose}
            color="primary"
            style={{
              textTransform: "none",
              fontWeight: "bold",
              color: "#1E88E5",
            }}
          >
            {t("Close")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default AssetConcentration
